import { ForeignerOTPs } from "pages/foreigner/ForeignerOTPs";
import { ThongKe } from "pages/ThongKeSoLieu";
import {
    AccountRegister,
    AccountRegisterHistory,
    ActionJob,
    ApprovalResult,
    AppVersion,
    BloodGroup,
    Citizen,
    Client,
    Config,
    Country,
    Crime,
    DashboardReport,
    DependentHistory,
    Device,
    Division,
    DrivingLicenseClass,
    Education,
    EmailLog,
    Foreigner,
    ForeignerPersonal,
    ForeignerRegister,
    Gender,
    IdpAdminEventLog,
    IdpEventLog,
    Job,
    JudicialRecords,
    Language,
    LicensingAgency,
    MaritalStatus,
    Nation,
    Nationality,
    NotificationEvent,
    NotificationLog,
    Parameter,
    PersonInfo,
    ProcessingStatus,
    ProcessStatusForeign,
    Relation,
    Religion,
    RequestLookup,
    Role,
    SecQuestion,
    SendOTP,
    SendReceptData,
    SmsLog,
    Specialize,
    Subject,
    SysCategory,
    Template,
    Unit,
    User,
    UserQrcode,
    UserTransaction,
    VNeIDJob,
} from "utils/constants";

export const menu = [
    {
        id: "home",
        label: "Home",
        items: [
            // { id: "dashboard", label: "Dashboard", icon: "pi pi-fw pi-home", to: "/dashboard" },
            { id: "thong-ke-so-lieu", label: "thong-ke-so-lieu", icon: "pi pi-fw pi-home", to: "/thong-ke-so-lieu" },
        ],
    },
    {
        id: "citizen",
        label: "Citizen",
        items: [
            { id: "account-registers", label: "Account Registers", icon: "pi pi-fw pi-check-square", to: "/account-registers" },
            { id: "notification-events", label: "Notification Event", icon: "pi pi-fw pi-check-square", to: "/notification-events" },
            { id: "citizens", label: "Citizens", icon: "pi pi-fw pi-id-card", to: "/citizens" },
            { id: "users", label: "Users", icon: "pi pi-fw pi-users", to: "/users" },
            { id: "citizen-otps", label: "Citizen OTPs", icon: "pi pi-fw pi-comment", to: "/citizen-otps" },
        ],
    },
    // {
    //     id: "foreigner",
    //     label: "Foreigner",
    //     items: [
    //         { id: "foreigners", label: "Foreigners", icon: "pi pi-fw pi-id-card", to: "/foreigners" },
    //         { id: "foreigner-registers", label: "Foreigner Registers", icon: "pi pi-fw pi-check-square", to: "/foreigner-registers" },
    //         { id: "foreigner-otps", label: "Foreigner OTPs", icon: "pi pi-fw pi-comment", to: "/foreigner-otps" },
    //     ],
    // },
    {
        id: "integration",
        label: "Integration",
        items: [{ id: "clients", label: "Clients", icon: "pi pi-fw pi-clone", to: "/clients" }],
    },
    {
        id: "category",
        label: "Category",
        items: [
            { id: "countries", label: "Countries", icon: "pi pi-fw pi-globe", to: "/countries" },
            { id: "nationalities", label: "Nationalities", icon: "pi pi-fw pi-globe", to: "/nationalities" },
            { id: "divisions", label: "Divisions", icon: "pi pi-fw pi-sitemap", to: "/divisions" },
            { id: "units", label: "Units", icon: "pi pi-fw pi-list", to: "/units" },
            { id: "nations", label: "Nations", icon: "pi pi-fw pi-slack", to: "/nations" },
            { id: "religions", label: "Religions", icon: "pi pi-fw pi-list", to: "/religions" },
            { id: "genders", label: "Genders", icon: "pi pi-fw pi-users", to: "/genders" },
            { id: "marital-status", label: "MaritalStatus", icon: "pi pi-fw pi-users", to: "/marital-status" },
            { id: "blood-groups", label: "Blood Groups", icon: "pi pi-fw pi-heart-fill", to: "/blood-groups" },
            { id: "relations", label: "Relations", icon: "pi pi-fw pi-list", to: "/relations" },
            { id: "crimes", label: "Crimes", icon: "pi pi-fw pi-list", to: "/crimes" },
            { id: "driving-license-classes", label: "Driving License Classes", icon: "pi pi-fw pi-list", to: "/driving-license-classes" },
            { id: "educations", label: "Educations", icon: "pi pi-fw pi-list", to: "/educations" },
            { id: "languages", label: "Languages", icon: "pi pi-fw pi-list", to: "/languages" },
            { id: "specializes", label: "Specializes", icon: "pi pi-fw pi-list", to: "/specializes" },
            { id: "licensingAgencies", label: "LicensingAgencies", icon: "pi pi-fw pi-list", to: "/licensingAgencies" },
            { id: "sysCategories", label: "SysCategories", icon: "pi pi-fw pi-list", to: "/sysCategories" },
            { id: "jobs", label: "Jobs", icon: "pi pi-fw pi-list", to: "/jobs" },
        ],
    },
    {
        id: "system",
        label: "System",
        items: [
            { id: "devices", label: "Devices", icon: "pi pi-fw pi-mobile", to: "/devices" },
            { id: "templates", label: "Templates", icon: "pi pi-fw pi-list", to: "/templates" },
            { id: "configs", label: "Configs", icon: "pi pi-fw pi-cog", to: "/configs" },
            { id: "app-versions", label: "Application Version", icon: "pi pi-fw pi-info-circle", to: "/app-versions" },
            { id: "sec-questions", label: "Security Questions", icon: "pi pi-fw pi-question", to: "/sec-questions" },
            { id: "parameters", label: "Parameters", icon: "pi pi-fw pi-cog", to: "/parameters" },
            { id: "action-job", label: "Action Job", icon: "pi pi-fw pi-book", to: "/action-job" },
            { id: "vneid-job", label: "VNeID Job", icon: "pi pi-fw pi-book", to: "/vneid-job" },
            { id: "roles", label: "Roles", icon: "pi pi-fw pi-key", to: "/roles" },
            { id: "subjects", label: "Subjects", icon: "pi pi-fw pi-book", to: "/subjects" },
        ],
    },
    {
        id: "log",
        label: "Log",
        items: [
            { id: "sms-logs", label: "SmsLogs", icon: "pi pi-fw pi-comment", to: "/sms-logs" },
            { id: "email-logs", label: "EmailLogs", icon: "pi pi-fw pi-inbox", to: "/email-logs" },
            // { id: "idp-event-logs", label: "IdpEventLogs", icon: "pi pi-fw pi-calendar", to: "/idp-event-logs" },
            // { id: "idp-admin-event-logs", label: "IdpAdminEventLogs", icon: "pi pi-fw pi-calendar", to: "/idp-admin-event-logs" },
            { id: "notification-logs", label: "Notification Logs", icon: "pi pi-fw pi-calendar", to: "/notification-logs" },
            { id: "user-transactions", label: "User Transactions", icon: "pi pi-fw pi-users", to: "/user-transactions" },
        ],
    },
    {
        id: "search",
        label: "Search",
        items: [
            { id: "account-registers-history", label: "Account Register History", icon: "pi pi-fw pi-check-square", to: "/account-registers-history" },
            { id: "request-lookup", label: "Request lookup", icon: "pi pi-fw pi-clone", to: "/request-lookup" },
            { id: "send-recept-data", label: "Send recept data", icon: "pi pi-fw pi-clone", to: "/send-recept-data" },
            { id: "personal-info", label: "Person Information", icon: "pi pi-fw pi-calendar", to: "/personal-info" },
            { id: "processing-status", label: "Processing Status", icon: "pi pi-fw pi-calendar", to: "/processing-status" },
            { id: "dependent-histories", label: "Dependent History ", icon: "pi pi-fw pi-calendar", to: "/dependent-histories" },
            { id: "approval-results", label: "Approval Results", icon: "pi pi-fw pi-calendar", to: "/approval-results" },
            { id: "foreigner-personal", label: "Foreigner Personal", icon: "pi pi-fw pi-calendar", to: "/foreigner-personal" },
            { id: "user-qrcode", label: "User Qrcode", icon: "pi pi-fw pi-calendar", to: "/user-qrcode" },
            { id: "process-status-foreign", label: "Process status foreign", icon: "pi pi-fw pi-calendar", to: "/process-status-foreign" },
        ],
    },
    {
        id: "logcommunicate",
        label: "Log Communicate",
        items: [{ id: "judicial-records", label: "Judicial Records", icon: "pi pi-fw pi-check-square", to: "/judicial-records" }],
    },
];

export const menuPermissions = {
    home: [],
    dashboard: [{ subject: User }, { subject: Client }],
    citizen: [{ subject: Citizen }, { subject: AccountRegister }, { subject: SendOTP }, { subject: NotificationEvent }],
    "notification-events": [{ subject: NotificationEvent }],
    "account-registers": [{ subject: AccountRegister }],
    citizens: [{ subject: Citizen }],
    "citizen-otps": [{ subject: SendOTP }],
    foreigner: [{ subject: Foreigner }, { subject: ForeignerRegister }, { subject: SendOTP }],
    "foreigner-registers": [{ subject: ForeignerRegister }],
    foreigners: [{ subject: Foreigner }],
    "foreigner-otps": [{ subject: ForeignerOTPs }],
    integration: [{ subject: Client }],
    clients: [{ subject: Client }],
    system: [{ subject: User }, { subject: Role }, { subject: Subject }, { subject: Config }, { subject: VNeIDJob }],
    users: [{ subject: User }],
    roles: [{ subject: Role }],
    subjects: [{ subject: Subject }],
    configs: [{ subject: Config }],
    parameters: [{ subject: Parameter }],
    "sec-questions": [{ subject: SecQuestion }],
    devices: [{ subject: Device }],
    "app-versions": [{ subject: AppVersion }],
    "action-job": [{ subject: ActionJob }],
    "thong-ke-so-lieu": [{ subject: DashboardReport }],
    // "vneid-job": [{ subject: ActionJob }],
    "vneid-job": [{ subject: VNeIDJob }],
    category: [
        { subject: Country },
        { subject: Unit },
        { subject: Division },
        { subject: BloodGroup },
        { subject: Gender },
        { subject: Nation },
        { subject: Religion },
        { subject: Nationality },
        { subject: Relation },
        { subject: MaritalStatus },
        { subject: Crime },
        { subject: DrivingLicenseClass },
        { subject: Education },
        { subject: Language },
        { subject: Specialize },
        { subject: LicensingAgency },
        { subject: SysCategory },
        { subject: Job },
    ],
    countries: [{ subject: Country }],
    units: [{ subject: Unit }],
    nations: [{ subject: Nation }],
    nationalities: [{ subject: Nationality }],
    religions: [{ subject: Religion }],
    divisions: [{ subject: Division }],
    "marital-status": [{ subject: MaritalStatus }],
    "blood-groups": [{ subject: BloodGroup }],
    relations: [{ subject: Relation }],
    crimes: [{ subject: Crime }],
    "driving-license-classes": [{ subject: DrivingLicenseClass }],
    educations: [{ subject: Education }],
    languages: [{ subject: Language }],
    genders: [{ subject: Gender }],
    specializes: [{ subject: Specialize }],
    templates: [{ subject: Template }],
    licensingAgencies: [{ subject: LicensingAgency }],
    jobs: [{ subject: Job }],
    sysCategories: [{ subject: SysCategory }],
    log: [{ subject: SmsLog }, { subject: EmailLog }, { subject: IdpEventLog }, { subject: IdpAdminEventLog }, { subject: NotificationLog }, { subject: UserTransaction }],
    "notification-logs": [{ subject: NotificationLog }],
    "sms-logs": [{ subject: SmsLog }],
    "email-logs": [{ subject: EmailLog }],
    "idp-event-logs": [{ subject: IdpEventLog }],
    "idp-admin-event-logs": [{ subject: IdpAdminEventLog }],
    "user-transactions": [{ subject: UserTransaction }],
    search: [
        { subject: DependentHistory },
        { subject: PersonInfo },
        { subject: ApprovalResult },
        { subject: ProcessingStatus },
        { subject: ForeignerPersonal },
        { subject: UserQrcode },
        { subject: ProcessStatusForeign },
        { subject: SendReceptData },
        { subject: RequestLookup },
        { subject: AccountRegisterHistory },
    ],
    "foreigner-personal": [{ subject: ForeignerPersonal }],
    "processing-status": [{ subject: ProcessingStatus }],
    "dependent-histories": [{ subject: DependentHistory }],
    "personal-info": [{ subject: PersonInfo }],
    "approval-results": [{ subject: ApprovalResult }],
    "user-qrcode": [{ subject: UserQrcode }],
    "process-status-foreign": [{ subject: ProcessStatusForeign }],
    "send-recept-data": [{ subject: SendReceptData }],
    "request-lookup": [{ subject: RequestLookup }],
    "account-registers-history": [{ subject: AccountRegisterHistory }],
    "judicial-records": [{ subject: JudicialRecords }],
    logcommunicate: [{ subject: JudicialRecords }],
};
